export enum TopBarMenuAcessoRapido {
  Assembleias,
  Presentes,
  Mensagens,
  Convocados,
  // Quorum
}